




































































import mixins from 'vue-typed-mixins'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import UserActionMixin from '@/mixins/UserActionMixin'
import * as qs from 'qs'
import config from '@/config'
import push from '@/push-notification'
import DatePicker from '@/components/DatePicker.vue'
import EditDate from '@/components/EditDate.vue'
import EditText from '@/components/EditText.vue'
import { calculateAge, getCookie, versionCompare, stringToCodePoints } from '@/utils/helpers'
import { required, valid } from '@/utils/form-utils'

// 登録時のリクエストパラメータ
interface RegistRequestParamter {
  gender: number
  name: string
  fuken: number
  app: '1' | '0'
  pin_code?: string
  banner_code?: string
  refer_code?: string
  sid?: string
  adid?: string
  history_id?: string
  y: number
  m: number
  d: number
}

const AgeLabel = {
  props: {
    age: {
      type: Number,
      required: true
    }
  },
  template: `
    <label class="label has-text-left">
      <span>生年月日</span>
      <span v-if="age > 0">({{ age }}歳)</span>
    </label>
  `
}

export default mixins(UserActionMixin).extend({
  name: 'Signup',
  components: {
    AgeLabel,
    DatePicker,
    EditDate,
    EditText
  },
  data() {
    return {
      account: null,
      activeTab: 0,
      year: null,
      month: null,
      date: null,
      birthday: '',
      birthdayInputType: 'text',
      dialog: null,
      fuken: 0,
      gender: 1,
      progress: false,
      name: '',
      clickedSignup: false
    }
  },
  computed: {
    ...mapGetters('Auth', ['isBan']),
    ...mapGetters('Profile', ['fukens', 'fukenGroups', 'bigCities']),

    registerButtonLabel(): string {
      return 'スタート'
    },

    /**
     * フォームの validation
     */
    validation(): any {
      const validationItems = {
        name: {
          required: required(this.name)
        },
        fuken: {
          required: required(this.fuken),
          format: this.selectedFuken
        },
        birthday: {
          required: required(this.birthday),
          format: this.over18yers
        }
      }
      return validationItems
    },

    /**
     * 地域を選択しているか
     */
    selectedFuken(): boolean {
      let val = this.fuken
      if (typeof val === 'string') {
        val = parseInt(val, 10)
      }
      return val > 0
    },

    /**
     * 18歳以上かどうか
     */
    over18yers(): boolean {
      return this.age >= 18
    },

    /**
     * 年齢
     */
    age(): number {
      return calculateAge(this.birthday)
    },

    /**
     * valid を用いて登録処理の可否
     */
    disableSignupAction(): boolean {
      return !valid(this.validation) || this.progress
    },

    nameLength(): number {
      return stringToCodePoints(this.name).length
    },

    pinCode(): string {
      return (this.$route.query.pin_code as string) || sessionStorage.getItem('pin_code')
    }
  },
  watch: {
    activeTab(val: number) {
      this.gender = val + 1
    },
    year(val: number) {
      this.calculateBirtyday()
    },
    month(val: number) {
      this.calculateBirtyday()
    },
    date(val: number) {
      this.calculateBirtyday()
    }
  },
  async created() {
    if (this.isBan) {
      this.$router.replace('/ban')
      return
    }

    // 登録ページにアクセスしたらトークンを必ずクリア(※登録できなくなる)
    this.$http.defaults.headers.common['TOKEN'] = ''

    if (this.$_hasCordova) {
      // ログアウトしてしまっても端末に ID/PASSWORD が残っていれば自動でログイン
      this.account = await this.$_secureGetAccount()
      if (this.account && this.account.userId && this.account.password) {
        this.$router.replace({
          name: 'login',
          params: {
            id: this.account.userId,
            password: this.account.password,
            hidden: '1'
          }
        })
        return
      }
    } else {
      // Web なら SMS 認証必須
      const data = await this.shouldSmsAuth({
        page: 'get_init',
        pin_code: this.$route.query.pin_code
      })
      if (data.url) {
        location.href = data.url
        return
      }

      if (this.$route.query.pin_code) {
        sessionStorage.setItem('pin_code', this.$route.query.pin_code as string)
      }
    }

    // 府県データが空ならサーバからロード
    if (
      Object.keys(this.fukens).length === 0 ||
      (this.fukens.message && this.fukens.message['length'] > 0)
    ) {
      // 住まいページでカクつかないように先に取得
      this.$store.dispatch('Profile/getFukens')
    }
  },
  destroyed() {
    if (this.dialog) {
      this.dialog.close()
    }
  },
  methods: {
    ...mapMutations('MyData', ['setMyProfile']),
    ...mapActions('Auth', ['shouldSmsAuth', 'signup']),
    ...mapActions('Profile', ['getFukens']),

    /**
     * スタートボタンタップ
     */
    async handleStartClick() {
      this.clickedSignup = true
      if (this.disableSignupAction) {
        return
      }

      if (this.$_platformIsAndroid) {
        // Android ならファイルへの読み書きを許可しないと history_id を使ったユーザ判定ができないので許可必須
        const hasPermission = await this.$_checkAllowAccessToMediaFiles()
        if (!hasPermission) {
          this.$_alert(
            `もう一度[${
              this.registerButtonLabel
            }]をタップして、ストレージ(写真、メディア、ファイル)へのアクセスを許可してください。`
          )
          return
        }
      }

      if (this.progress) return
      this.progress = true

      try {
        // 送信するパラメータの準備
        const [y, m, d] = this.birthday.split('-')
        const cookie = getCookie()
        const appParams = {}
        let app = '0'

        if (this.$_hasCordova) {
          app = '1'
          appParams['adid'] = await this.$_getAdid()
          appParams['history_id'] = this.account.historyId
          appParams['uuid'] = device.uuid
        }

        const params = {
          app,
          name: this.name,
          y,
          m,
          d,
          gender: this.gender,
          fuken: this.fuken,
          pin_code: this.pinCode, // 電話番号認証(Web登録時)
          banner_code: cookie.b, // バナーコード
          refer_code: cookie.r, // 友達紹介コード
          sid: cookie.sid, // ?
          ...appParams
        }

        const data = await this.signup(params)
        if (data.error) {
          this.$_alert(data.error)
          this.progress = false
          return
        }

        if (this.$_hasCordova) {
          try {
            // ユーザ情報を端末に保存
            await this.$_secureSaveAccount({
              userId: data.user_id,
              password: data.password,
              historyId: data.history_id
            })
          } catch (err) {
            console.error(err)
            this.$_alert(
              'ファイルの読み込み失敗。ストレージ(写真、メディア、ファイル)へのアクセスを許可してください。'
            )
            this.progress = false
            return
          }

          push.initPushNotification(this.$root)
          if (this.$_platformIsIOS && versionCompare(device.version, '9.3.5')) {
            push.initVoIPPushNotification(this.$root)
          }

          const adjustEvent = new window.AdjustEvent(config.ADJUST_EVENT_REGIST)
          window.Adjust.trackEvent(adjustEvent)
        }

        // 女性で登録しても TOP で女性一覧が表示されてしまうので TopUser/entries をクリア
        this.$store.commit('TopUser/clearEntries')

        // Web ユーザはアプリ起動
        if (this.pinCode) {
          this.$_tryLaunchApp(`login/${data.user_id}/${data.password}`)
          return
        }

        // 入力したプロフィールのセット
        this.setMyProfile({
          name: this.name,
          gender: this.gender + '',
          fuken: this.fuken,
          y: this.year,
          m: this.month,
          d: this.date
        })

        this.$router.replace('/')
      } catch (err) {
        console.error(err)
      } finally {
        this.progress = false
      }
    }
  }
})
